/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getPOJOPathAndSearchFiltersFromUrl
 */

import type { Filters } from '@zcode/state-type'
import { convertQueryStringToParams } from '@zcode/utils'
import { createLocation } from 'history'

import { matchRoutes } from '@zcode/router-utils'

import { currentSearchRoutes } from '@zcode/zumper-routes'
import { getFiltersFromUrlFiltersPathHelper } from './getFiltersFromUrlFiltersPath'
import { parseFiltersFromSearchObject } from './parseFiltersFromSearchObject'

export const getPOJOPathAndSearchFiltersFromUrl = (url: string) => {
  const location = createLocation(url)
  let pathFilters: Partial<Filters> = {}
  let searchFilters: Partial<Filters> = {}

  const { match } = matchRoutes(currentSearchRoutes, location)[0] || {}
  const { search } = location

  if (match) {
    const { params } = match
    const { filtersPath } = params as { filtersPath?: string }

    if (filtersPath && filtersPath !== '/') {
      pathFilters = getFiltersFromUrlFiltersPathHelper(filtersPath, {})
    }
  }

  if (search) {
    searchFilters = parseFiltersFromSearchObject(convertQueryStringToParams(search))
  }

  return { ...pathFilters, ...searchFilters }
}
